import { render, staticRenderFns } from "./ColorPreview.vue?vue&type=template&id=1f4de8aa&scoped=true&"
import script from "./ColorPreview.vue?vue&type=script&lang=js&"
export * from "./ColorPreview.vue?vue&type=script&lang=js&"
import style0 from "./ColorPreview.vue?vue&type=style&index=0&id=1f4de8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4de8aa",
  null
  
)

export default component.exports